import CloudIcon from '@liquidweb-dev/undercurrent/icons/lucide/Cloud';
import GlobeIcon from '@liquidweb-dev/undercurrent/icons/lucide/Globe';
import UCGpuIcon from '@liquidweb-dev/undercurrent/icons/lucide/Gpu';
import Layers2Icon from '@liquidweb-dev/undercurrent/icons/lucide/Layers2';
import ServerIcon from '@liquidweb-dev/undercurrent/icons/lucide/Server';
import VmwareIcon from '@liquidweb-dev/undercurrent/icons/platform/Vmware';
import { type FixedColorSvgProps } from '@liquidweb-dev/undercurrent/types/svgTypes';

import { type AssetDetails } from 'modules/queries/asset/useDetails';

export interface DisplayTypeIconProps extends FixedColorSvgProps {
	displayType: AssetDetails['displayType'];
}

const DisplayTypeIcon = ({ displayType, ...rest }: DisplayTypeIconProps) => {
	const displayTypeLowerCase = displayType?.toLowerCase() || '';

	if (displayTypeLowerCase.includes('vmware')) {
		return <VmwareIcon {...rest} />;
	}

	if (displayTypeLowerCase.includes('vps')) {
		return <Layers2Icon {...rest} />;
	}

	if (displayTypeLowerCase.includes('cloud')) {
		return <CloudIcon {...rest} />;
	}

	if (displayTypeLowerCase.includes('gpu accelerated')) {
		return <UCGpuIcon {...rest} />;
	}

	if (
		displayTypeLowerCase.includes('ip pool') ||
		displayTypeLowerCase.includes('load balancer')
	) {
		return <GlobeIcon {...rest} />;
	}

	return <ServerIcon {...rest} />;
};

export default DisplayTypeIcon;
